// extracted by mini-css-extract-plugin
export default {"wrapper":"create_wrapper__ngKW-"};